export const staff_tracking = {
  title: `Personeel Volgen`,

  staff: `Gebruiker`
};